import script from "./boat-launch-filter.vue?vue&type=script&setup=true&lang=ts"
export * from "./boat-launch-filter.vue?vue&type=script&setup=true&lang=ts"

import "./boat-launch-filter.vue?vue&type=style&index=0&id=3253cbe5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3253cbe5"]])

export default __exports__